import * as React from "react"
import { Widget, mk_widget } from "widgets-for-react"
import { styleguideAbout } from "./components/about"
import { styleguideGuidelines } from "./components/guidelines"
import { styleguideTokens } from "./components/tokens"
import { styleguideObjects } from "./components/objects"
import { styleguideComponents } from "./components/components"
import { styleguideCompositions } from "./components/compositions"
import { Icons } from "../components/public_site/templates/icons"

export type StyleguideState = {
  page: 'about' | 'guidelines' | 'tokens' | 'objects' | 'components' | 'compositions'
}

const splitHash = () => {
  return window.location.hash.split('#')[1].split('-')[0];
}

const $breakpoint = 768;

export let currentPage = window.location.hash ? splitHash() :'tokens'

const __ = ():any => null

export const styleguide: Widget<never> = mk_widget({
  run: _ => (
    <>
      <article className="styleguide">
        <div className="styleguide__main">
          <header className="styleguide__header">
            <div className="styleguide__brand">
              <div className="styleguide__wrap">
                <svg className="styleguide__logo styleguide__logo--mobile" height="40" width="229"  aria-hidden="true">
                  <use xlinkHref="#image--logo"/>
                </svg>
                <span className="styleguide__subtitle styleguide__subtitle--mobile" aria-hidden="true">Style guide</span>
              </div>
              <button className="styleguide-toggler" onClick={e => document.documentElement.classList.toggle('styleguide-nav--toggled')}>
                <span className="sr-text">Toggle Menu</span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <svg className="styleguide-toggler__icon" height="16" width="10"  aria-hidden="true"><use xlinkHref="#chevron--left"/></svg>
              </button>
            </div>

            <div className="styleguide-nav__wrapper" data-active-page={currentPage}>
              <nav className="styleguide-nav">
                <a className="styleguide__logo-link" href="/styleguide">
                  <h1 className="sr-text">Styleguide 'Dubbeldam'</h1>
                  <svg className="styleguide__logo styleguide__logo--desktop" height="40" width="229"  aria-hidden="true">
                    <use xlinkHref="#image--logo"/>
                  </svg>
                  <span className="styleguide__subtitle styleguide__subtitle--desktop" aria-hidden="true">Style guide Dubbeldam</span>
                </a>

                <h2 className="sr-text">Menu</h2>
                <ul className="styleguide-nav__list">
                  <li className="styleguide-nav__item styleguide-nav__item--styleguide">
                    <a className="styleguide-nav__link styleguide-nav__link--main styleguide-nav__toggler" href="#designsystem" onClick={e => [currentPage = 'designsystem', document.documentElement.classList.toggle('styleguide-designsystem--toggled')]}>
                      <svg className="styleguide-nav__icon" height="22" width="22"  aria-hidden="true"><use xlinkHref="#nav--styleguide"/></svg>
                      Design System
                    </a>
                    <ul className="styleguide-nav__dropdown styleguide-nav__dropdown--styleguide">
                      <li className="styleguide-nav__item styleguide-nav--tokens">
                        <a className="styleguide-nav__link styleguide-nav__toggler" href="#tokens" onClick={e => [currentPage = 'tokens', document.documentElement.classList.toggle('styleguide-tokens--toggled')]}>Design Tokens</a>

                        <ul className="styleguide-nav__sublist">
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-colors" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Colors</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-fonts" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Fonts</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-styles" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Font Styles</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-sizes-heights" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Font Sizes &amp; Line Heights</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-widths" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Widths</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-spacings-gutters" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Spacings &amp; Gutters</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#tokens-icons" onClick={e => [currentPage = 'tokens', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Icons</a>
                          </li>
                        </ul>
                      </li>
                      <li className="styleguide-nav__item styleguide-nav--objects">
                        <a className="styleguide-nav__link styleguide-nav__toggler" href="#objects" onClick={e => [currentPage = 'objects', document.documentElement.classList.toggle('styleguide-objects--toggled')]}>Design Objects</a>

                        <ul className="styleguide-nav__sublist">
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#objects-buttons" onClick={e => [currentPage = 'objects', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Buttons</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#objects-links" onClick={e => [currentPage = 'objects', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Links</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#objects-lists" onClick={e => [currentPage = 'objects', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Lists</a>
                          </li>
                        </ul>
                      </li>
                      <li className="styleguide-nav__item styleguide-nav--components">
                        <a className="styleguide-nav__link styleguide-nav__toggler" href="#components" onClick={e => [currentPage = 'components', document.documentElement.classList.toggle('styleguide-components--toggled')]}>Design Components</a>

                        <ul className="styleguide-nav__sublist">
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#site-header" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Site header</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#footer" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Footer</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#page-header" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Page header</a>
                          </li>
                         
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#text-block" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Text block</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#download-list-block" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Download list block</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#featured-content-block" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Featured content block</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#quote-block" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Quote block</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#image-text-blocks" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Image + text blocks</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#grid-blocks" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Grid blocks</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#media-block" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Media block</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#cta-blocks" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Call To Action blocks</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#gallery-block" onClick={e => [currentPage = 'components', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Gallery block</a>
                          </li>
                        </ul>
                      </li>
                      <li className="styleguide-nav__item styleguide-nav--compositions">
                        <a className="styleguide-nav__link styleguide-nav__toggler" href="#compositions" onClick={e => [currentPage = 'compositions', document.documentElement.classList.toggle('styleguide-compositions--toggled')]}>Design Compositions</a>

                        <ul className="styleguide-nav__sublist">
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#composition-homepage" onClick={e => [currentPage = 'compositions', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Homepage</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#composition-overview" onClick={e => [currentPage = 'compositions', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Overview page</a>
                          </li>
                          <li className="styleguide-nav__item">
                            <a className="styleguide-nav__link" href="#composition-detail" onClick={e => [currentPage = 'compositions', (window.innerWidth < $breakpoint) && document.documentElement.classList.remove('styleguide-nav--toggled')]}>Detail page</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>

              <div className="styleguide__extra">
                <button className="styleguide__extra-button">Log out</button>
              </div>
            </div>
          </header>

          <div className="styleguide__content">
            {currentPage == 'about' ?
              styleguideAbout.run(__) :
              currentPage == 'guidelines' ?
                styleguideGuidelines.run(__) :
                currentPage == 'tokens' ?
                  styleguideTokens.run(__) : 
                  currentPage == 'objects' ?
                    styleguideObjects.run(__) :
                    currentPage == 'components' ?
                      styleguideComponents.run(__) :
                      currentPage == 'compositions' ?
                        styleguideCompositions.run(__) :
                          currentPage == 'brandguide' ?
                            <section className="styleguide-chapter styleguide-chapter--brandguide">
                            <header className="styleguide--styled styleguide-chapter__header">
                              <h2 className="styleguide__title styleguide-chapter__title">Logo</h2>
                              <p className="styleguide-chapter__intro">With the editor you can post texts and images here. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. </p>
                            </header>
                            <div className="styleguide-chapter__content">
                              <section id="tokens-colors" className="styleguide-section styleguide-section--brandguide">
                                <div className="styleguide-chapter__text styleguide--styled">
                                  <h3>Our primary logo with Nourishing by Nature</h3>
                                  <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p>
                                  <ul>
                                    <li>
                                      <a>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</a>
                                    </li>
                                    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. </li>
                                    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. </li>
                                  </ul>
                                  <ol>
                                    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. </li>
                                    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. </li>
                                    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. </li>
                                  </ol>
                                  <img src="../styleguide/images/Logo-label.svg"/>
                                </div>
                              </section>
                            </div>
                          </section>:
                            <section className="styleguide-chapter styleguide-chapter--home">
                              <header className="styleguide--styled styleguide-chapter__header">
                                <h2 className="styleguide__title styleguide-chapter__title">Welkom bij onze Style Guide!</h2>
                                <p className="styleguide-chapter__intro">Hier vind je alles wat je nodig hebt om ons merk digitaal te bouwen.</p>
                              </header>
                              <div className="styleguide-chapter__content">
                                <section id="tokens-colors" className="styleguide-section styleguide-section--home">
                                  <ul className="styleguide-section__list">
                                    <li  className="styleguide-section__item">
                                      <h3 className="styleguide-section__title">
                                        <svg className="styleguide-nav__icon" height="44" width="44" aria-hidden="true"><use xlinkHref="#nav--styleguide" /></svg>
                                        Design System
                                      </h3>
                                    </li>
                                  </ul>
                                  <p className="styleguide-section__copy">Hierin zijn onze digitale bouwstenen gedefinieerd.</p>
                                  <h3 className="styleguide-section__title">
                                    <svg className="styleguide-nav__icon" height="44" width="44" aria-hidden="true"><use xlinkHref="#nav--brandguide" /></svg>
                                    Brandguide
                                  </h3>
                                  <p className="styleguide-section__copy">Hierin zijn onze digitale bouwstenen gedefinieerd.</p>
                                  <h3 className="styleguide-section__title">
                                    <svg className="styleguide-nav__icon" height="44" width="44" aria-hidden="true"><use xlinkHref="#nav--voice" /></svg>
                                    Voice & Tone
                                  </h3>
                                  <p className="styleguide-section__copy">Hierin zijn onze digitale bouwstenen gedefinieerd.</p>
                                  <h3 className="styleguide-section__title">
                                    <svg className="styleguide-nav__icon" height="44" width="44" aria-hidden="true"><use xlinkHref="#nav--assets" /></svg>
                                    Assets
                                  </h3>
                                  <p className="styleguide-section__copy">Hierin zijn onze digitale bouwstenen gedefinieerd.</p>
                                </section>
                              </div>
                            </section> 
            }
          </div>
        </div>

        <svg xmlns="https://www.w3.org/2000/svg" style={{ display: "none" }} aria-hidden="true">
        <Icons />

         
        </svg>
      </article>
    </>
  )
})